import {useState} from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import config from '../../config/config';
import CustomInputLabel from './CustomInputLabel';
import CustomInput from './CustomInput';

export const colorOptions = () => ([
  config().colors.primary,
  config().colors.secondary,
  // config().colors.success,
  config().colors.deepTeal,
  config().colors.lightTeal,
  config().colors.goldSand,
  config().colors.lightOrange,
  // config().colors.info,
  // config().colors.purple,
  // config().colors.warning,
  // "#f44336", "#e91e63", "#9c27b0", "#673ab7",
  // "#3f51b5",  "#2196f3", "#03a9f4", "#00bcd4",
  // "#009688", "#4caf50", "#8bc34a", "#cddc39",
  // "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
  // "#795548", "#607d8b"
]);

const CustomSwatch = ({
  color, 
  onChange,
  isSelected,
}) => (
  <Box
    key={color}
    style={{
      width: '30px',
      height: '30px',
      cursor: 'pointer',
      float: 'left',
      borderRadius: '4px',
      margin: '0 6px 6px 0',
      backgroundColor: color,
      border: isSelected ? '2px black solid' : '2px transparent solid',
    }}
    sx={{
      '&:hover': {boxShadow: '0px 0px 0px 1px #0000001A'},
    }}
    onClick={e => onChange({...e, target: {...e.target, value: color}}, color)}
  />
);

const ColorPicker = props => {
  const [color, setColor] = useState(props.defaultValue || null);
  const colors = props?.colors || colorOptions();
  return (
    <CustomInput>
      {!!props?.label && 
        <CustomInputLabel label={props.label} required={props.required}>
          {props.label}
        </CustomInputLabel>
      }
      <Stack direction='row' spacing={.5}>
        {
          colors.map((c) => 
            <CustomSwatch 
              color={c}
              isSelected={color === c}
              onChange={(e, color) => {
                setColor(c);
                props.onChange(e, c);
              }}
            />
          )
        }
      </Stack>
    </CustomInput>
  );
};

export default ColorPicker;


